import { Stack, Link, Typography, Box, Container } from '@mui/material';
import AlmaLogo from '../../resources/CompanyFooterLogo.svg?react';
import { useTranslation } from 'react-i18next';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {
  customerServiceEmail,
  customerServicePhone,
} from '../../utilities/Links';
import AlmaFooterWidget from './AlmaFooterWidget';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#121212',
      }}
    >
      <Container
        maxWidth='lg'
        disableGutters
        sx={{ paddingX: 2, flex: 1, paddingY: 8 }}
      >
        <Stack
          direction={{ xs: 'column' }}
          spacing={{ xs: 3, lg: 8 }}
          sx={{
            justifyContent: { xs: 'flex-start', lg: 'space-between' },
            alignItems: 'flex-start',
          }}
        >
          <Stack
            direction={{ xs: 'column', lg: 'row' }}
            spacing={3}
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              width: '100%',
            }}
          >
            <Box
              sx={{
                marginBottom: 3,
                width: '100%',
              }}
            >
              <Link
                href='https://almainsights.fi'
                target='_blank'
                rel='noreferrer'
                sx={{ display: 'block' }}
              >
                <AlmaLogo data-testid='alma-talent-logo' />
              </Link>
            </Box>

            <Box sx={{ width: '100%' }}>
              <Typography
                component='h2'
                variant='subtitle2'
                sx={{
                  marginBottom: 0.5,
                  color: 'white',
                }}
              >
                {t('footer.customerService')}
              </Typography>
              <Typography variant='body2' sx={{ color: 'white' }}>
                {t('footer.contactViaEmail')}
              </Typography>
              <Link
                href={'mailto:' + customerServiceEmail}
                target='_blank'
                rel='noopener noreferrer'
                variant='body2'
                underline='always'
                sx={{
                  marginY: 1.75,
                  color: 'white',
                  display: 'block',
                }}
              >
                {customerServiceEmail}
              </Link>
              <Typography
                variant='body2'
                sx={{
                  paddingTop: 1,
                  color: 'white',
                }}
              >
                {t('footer.phone') + ':'}
              </Typography>
              <Typography variant='body2' sx={{ color: 'white' }}>
                {customerServicePhone}
              </Typography>
              <Typography variant='body2' sx={{ color: 'white' }}>
                {t('footer.customerServiceOpeningHours')}
              </Typography>
            </Box>
            <Box sx={{ width: '100%' }}>
              <Link
                href='https://www.almainsights.fi/sopimusehdot/'
                target='_blank'
                rel='noopener noreferrer'
                variant='body2'
                underline='always'
                sx={{
                  marginY: { xs: 1.75, md: 0.5 },
                  color: 'white',
                  display: 'block',
                }}
              >
                {t('footer.termsOfUse')}
              </Link>
            </Box>
          </Stack>
          <Stack
            direction={{ xs: 'column', lg: 'row' }}
            spacing={3}
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              width: '100%',
            }}
          >
            <Typography variant='body2' sx={{ color: 'white', width: '100%' }}>
              {t('footer.mailAddress')}
            </Typography>
            <Typography variant='body2' sx={{ color: 'white', width: '100%' }}>
              {t('footer.address')}
            </Typography>
            <Box sx={{ width: '100%' }}>
              <Link
                href='https://www.facebook.com/Almainsights'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Facebook'
                sx={{
                  padding: 1.5,
                  color: 'white',
                  display: 'inline-flex',
                }}
              >
                <FacebookRoundedIcon />
              </Link>
              <Link
                href='https://www.linkedin.com/company/alma-insights'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='LinkedIn'
                sx={{
                  padding: 1.5,
                  color: 'white',
                  display: 'inline-flex',
                }}
              >
                <LinkedInIcon />
              </Link>
            </Box>
          </Stack>
        </Stack>
      </Container>
      <Box sx={{ backgroundColor: '#333' }}>
        <Container maxWidth='lg' disableGutters sx={{ paddingX: 2, flex: 1 }}>
          <Stack
            id='alma-content-router-footer'
            alignItems='center'
            sx={{ marginX: -3 }}
          >
            <AlmaFooterWidget />
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
